import { getStorage } from "firebase/storage";
import app from "./app";
import { projectSelector } from "@rflocal/shared";

// Initialize Firebase Storage to use the same bucket as the backend
// This matches the rapidPreviewInputBucket from storageAdapter.js
// Uses projectSelector.bucket() to get the correct bucket name for the current environment
const bucketName = projectSelector.bucket("iris-input-data");
export const storage = getStorage(app, `gs://${bucketName}`);

export default storage;
